import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';

const OverlayBannerSection = ({
  section,
  sectionIndex,
  renderHtmlTextBlock,
  renderPositionableElement,
}) => {
  const backgroundImage = section?.image || '';
  const title = section?.title || '';
  const body = section?.body || '';
  const buttonLabel = section?.buttonLabel || '';
  const buttonPath = section?.buttonPath || '';
  const imagePosition = section?.imageObjectPosition || 'center center';

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        minHeight: { xs: 340, md: 420 },
        overflow: 'hidden',
        backgroundColor: '#0A1424',
      }}
    >
      {backgroundImage ? (
        <Box
          component="img"
          src={backgroundImage}
          alt={title || 'Overlay banner'}
          sx={{
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            objectPosition: imagePosition,
          }}
        />
      ) : null}

      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          background:
            'linear-gradient(90deg, rgba(7,12,24,0.9) 0%, rgba(10,20,39,0.72) 42%, rgba(10,20,39,0.28) 100%)',
        }}
      />

      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          display: 'flex',
          alignItems: 'center',
          px: { xs: 2, md: 5, xl: 7 },
          py: { xs: 4, md: 5 },
        }}
      >
        <Box sx={{ width: '100%', maxWidth: 860 }}>
          <Stack spacing={1.5}>
            <Box sx={{ width: 80, height: 3, bgcolor: '#F8C35B' }} />
            {renderPositionableElement({
              section,
              index: sectionIndex,
              elementKey: 'overlay-title',
              showHandle: true,
              children: (
                <Typography
                  sx={{
                    color: '#FFFFFF',
                    fontSize: { xs: '2rem', md: '3.8rem' },
                    lineHeight: { xs: 1.08, md: 1 },
                    fontWeight: 800,
                    letterSpacing: '-0.04em',
                    maxWidth: 920,
                  }}
                >
                  {title}
                </Typography>
              ),
            })}
            {body
              ? renderPositionableElement({
                  section,
                  index: sectionIndex,
                  elementKey: 'overlay-body',
                  showHandle: true,
                  children: renderHtmlTextBlock(body, {
                    maxWidth: { xs: '100%', md: '72%' },
                    color: 'rgba(241,245,249,0.92)',
                    '& p': { mt: 0, mb: 0.35 },
                    fontSize: { xs: '1rem', md: '1.12rem' },
                    lineHeight: 1.7,
                  }),
                })
              : null}
            {buttonLabel ? (
              <Box sx={{ pt: 0.7 }}>
                <Button
                  variant="contained"
                  onClick={() => {
                    if (buttonPath) {
                      window.location.assign(buttonPath);
                    }
                  }}
                  sx={{
                    background: 'linear-gradient(135deg, #A1181F 0%, #C53030 100%)',
                    color: '#FFFFFF',
                    fontWeight: 800,
                    px: 2.6,
                    py: 1.05,
                    borderRadius: 6,
                    boxShadow: '0 14px 28px rgba(161,24,31,0.28)',
                    '&:hover': {
                      background: 'linear-gradient(135deg, #8F1217 0%, #A1181F 100%)',
                      boxShadow: '0 18px 32px rgba(161,24,31,0.3)',
                    },
                  }}
                >
                  {buttonLabel}
                </Button>
              </Box>
            ) : null}
          </Stack>
        </Box>
      </Box>
    </Box>
  );
};

export default OverlayBannerSection;
